import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { getStorage } from '../utils/storegeUtils';
import i18n from './i18n';

export default function I18nProvider({ children }) {
  const locale = getStorage('i18nextLng') || 'en';
  i18n.changeLanguage(locale);
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
